import React from "react";
import "./Thailand.css";
import countriesData from "../../data/countries.json";
import ThailandImage from "../../assets/ThailandImage.jpg";
import Navbar from "../../components/Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import ChatWithUs from "../../components/ChatWithUs/ChatWithUs";

const Thailand = () => {
  const navigate = useNavigate();

  const thailandCategories =
    countriesData.find((country) => country.country === "Thailand")
      ?.categories || [];

  const handleClick = (category) => {
    navigate("/products", {
      state: {
        country: "Thailand",
        category: category.name,
        products: category.products || [],
      },
    });
  };

  return (
    <>
      <Navbar />
      <div className="thailand-container">
        <div
          className="thailand-banner"
          style={{ backgroundImage: `url(${ThailandImage})` }}
        >
          <h1>Products from Thailand</h1>
        </div>

        <div className="thailand-products">
          {thailandCategories.map((cat, idx) => (
            <div
              key={idx}
              className="thailand-product-card"
              onClick={() => handleClick(cat)}
              style={{ cursor: "pointer" }}
            >
              <img src={cat.Image} alt={cat.name} />
              <p>{cat.name}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
      <ChatWithUs />
    </>
  );
};

export default Thailand;
